import styled from 'styled-components';

export const AlertsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginXS}px;

  .all-selection {
    display: flex;
    align-items: center;
    height: 32px;
  }

  .archive-all-icon {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  }
`;

export const AlertEmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme: { token } }) => token.paddingLG}px 0;
  gap: ${({ theme: { token } }) => token.marginXS}px;

  .alert-empty-icon {
    color: ${({ theme: { token } }) => token.colorIcon};
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  }

  .alert-empty-text {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .alert-empty-description {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  }
`;
